import React, { useEffect, useState } from 'react';
import { getUsers, createUser, updateUser } from '../api.js';


function userNameLabel(value) {
  if (value === 'Bootstrap admin') {
    return 'Администратор';
  }

  return value;
}


export default function Users() {
  const [users, setUsers] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [form, setForm] = useState({
    email: '',
    password: '',
    display_name: '',
    role: 'admin',
  });
  const [error, setError] = useState(null);

  const load = () =>
    getUsers()
      .then(setUsers)
      .catch((e) => setError(e.message));

  useEffect(() => {
    load();
  }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      await createUser({
        ...form,
        role: 'admin',
      });

      setForm({
        email: '',
        password: '',
        display_name: '',
        role: 'admin',
      });

      setShowCreate(false);
      load();
    } catch (err) {
      setError(err.message);
    }
  };

  const toggleActive = async (user) => {
    try {
      await updateUser(
        user.id,
        {
          is_active: !user.is_active,
        },
      );

      load();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <>
      <h1>Доступ к Hub</h1>

      <p style={{ color: '#718096', marginBottom: 24 }}>
        Здесь управляются только технические администраторы Hub.
        Сотрудники, очереди и ответственные по диалогам настраиваются
        в Открытых линиях Bitrix24.
      </p>

      <div style={{ marginBottom: 24 }}>
        <button
          className="btn-primary"
          onClick={() => setShowCreate(!showCreate)}
        >
          {showCreate ? 'Отмена' : '+ Добавить администратора'}
        </button>
      </div>

      {showCreate && (
        <div
          className="card"
          style={{ marginBottom: 24, padding: 16 }}
        >
          <form onSubmit={handleCreate}>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                required
                value={form.email}
                onChange={(e) =>
                  setForm({
                    ...form,
                    email: e.target.value,
                  })
                }
              />
            </div>

            <div className="form-group">
              <label>Пароль (минимум 8 символов)</label>
              <input
                type="password"
                required
                minLength={8}
                value={form.password}
                onChange={(e) =>
                  setForm({
                    ...form,
                    password: e.target.value,
                  })
                }
              />
            </div>

            <div className="form-group">
              <label>Имя</label>
              <input
                type="text"
                value={form.display_name}
                onChange={(e) =>
                  setForm({
                    ...form,
                    display_name: e.target.value,
                  })
                }
              />
            </div>

            <button
              type="submit"
              className="btn-primary"
            >
              Создать администратора
            </button>
          </form>
        </div>
      )}

      {error && (
        <div
          style={{
            background: '#fff5f5',
            color: '#c53030',
            padding: 12,
            marginBottom: 16,
            borderRadius: 6,
          }}
        >
          {error}
        </div>
      )}

      <div className="card">
        <table>
          <thead>
            <tr>
              <th>Почта</th>
              <th>Имя</th>
              <th>Роль</th>
              <th>Статус</th>
              <th>Действия</th>
            </tr>
          </thead>

          <tbody>
            {users.length === 0 && (
              <tr>
                <td
                  colSpan={5}
                  style={{
                    textAlign: 'center',
                    color: '#a0aec0',
                  }}
                >
                  Нет администраторов
                </td>
              </tr>
            )}

            {users.map((user) => (
              <tr key={user.id}>
                <td>
                  <strong>{user.email}</strong>
                </td>

                <td>
                  {userNameLabel(user.display_name) || '-'}
                </td>

                <td>
                  {user.role === 'admin'
                    ? 'Администратор'
                    : `Legacy: ${user.role}`}
                </td>

                <td>
                  <span
                    className={`badge ${
                      user.is_active
                        ? 'badge-ok'
                        : 'badge-error'
                    }`}
                  >
                    {user.is_active
                      ? 'Активен'
                      : 'Отключён'}
                  </span>
                </td>

                <td>
                  <button
                    className="btn-ghost btn-sm"
                    onClick={() => toggleActive(user)}
                  >
                    {user.is_active
                      ? 'Отключить'
                      : 'Включить'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
